export default "__VITE_ASSET__665b93af__"